export const blogData = [
    {
        id: 1,
        title: 'React Routing for advance developers',
        description: 'Routing in react js like a pro developer',
        date: 'Jan 3, 2022',
        image: 'https://res.cloudinary.com/modus-create-inc/images/v1610405523/extjs-react-how-to-configure-routes-00/extjs-react-how-to-configure-routes-00.jpg',
        url: 'https://medium.com/@officialsiddharthbisht/react-routing-for-advance-developers-18f76beca1c9'
    },
    {
        id: 2,
        title: 'React Version Downgrade',
        description: `But why to downgrade the version of react
        There are certain npm packages which does not support on latest react versions, therefore there is a need for react version downgrade to 16.`,
        date: 'Dec 28, 2022',
        image: 'https://1.bp.blogspot.com/-OW7jX57tea4/XvnGxuEOslI/AAAAAAAABW0/R8lVT1AXDSwnvE0EGA9Ra49-LDm1ACwDgCK4BGAsYHg/s1216/wttr1.png',
        url: 'https://medium.com/@officialsiddharthbisht/react-latest-version-18-or-above-to-react-16-a480e8702fc6'
    },
    {
        id: 3,
        title: 'The Rise of the MERN Stack: A Powerful Combination for Modern Web/App Development',
        description: 'In the fast-paced world of web development, staying ahead of the curve is crucial.',
        date: 'June 8, 2023',
        image: 'https://1.bp.blogspot.com/-GR19yCNbKCE/XuRcKEfKvhI/AAAAAAAAAwY/srFWw5pOpzMibeJb__SmgZpx9dIpNNWqgCK4BGAsYHg/w640-h426/anonymous1.jpg',
        url: 'https://medium.com/@officialsiddharthbisht/the-rise-of-the-mern-stack-a-powerful-combination-for-modern-web-app-development-405bab2a00a1'
    },
    // {
    //     id: 4,
    //     title: 'CHECK INTERNET SPEED FROM THE COMMAND LINE',
    //     description: 'Want to check your internet speed from the terminal? Here\'s the perfect way to the that.',
    //     date: 'Sep 17, 2020',
    //     image: 'https://1.bp.blogspot.com/-XTVMsZP3HaM/Xxpl394txlI/AAAAAAAABws/zovXWiuNGg4TzBwYYVFfJ1ixDb3JfVokgCNcBGAsYHQ/w400-h195/speedtest.png',
    //     url: 'https://hackzism.blogspot.com/2020/07/check-internet-speed-from-command-line.html'
    // },
    // {
    //     id: 5,
    //     title: 'GET MICHAEL\'S OR TREVOR\'S VEHICLES FULLY UPGRADED IN GTA V FOR FREE',
    //     description: 'In case you haven\'t heard of this game, GTA stands for \'Grand Theft Auto\'. It is an open-world game published by Rockstar Games.',
    //     date: 'Oct 1, 2020',
    //     image: 'https://1.bp.blogspot.com/-jhdtUBIRD_s/XxLFKQuRz9I/AAAAAAAABsM/mClfbfDFKvsUwA7Wyi25Lzu3DEmL2lxrACNcBGAsYHQ/s1919/gta.jpg',
    //     url: 'https://hackzism.blogspot.com/2020/07/how-can-you-get-michaels-or-trevors.html'
    // },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/